'use client';

import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';

function normalizeBrandCopy(value) {
  return String(value || '')
    .replace(/Trainaifit\.health\s+Home Health/gi, 'biogalfhomehealth.com')
    .replace(/TrainAIfit\.HEALTH\s+Home Health/gi, 'biogalfhomehealth.com')
    .replace(/trainaifit\.health\s+Home Health/gi, 'biogalfhomehealth.com')
    .replace(/\s+Home Health/gi, '')
    .replace(/TrainAIfit\.HEALTH/gi, 'biogalfhomehealth.com');
}

export default function LegalPrivacyPage() {
  const locale = useLocale();
  const tLanding = useTranslations('Landing');
  const t = useTranslations();
  const isRtl = locale === 'ar';

  const clauses = (() => {
    try {
      const rawClauses = t.raw('legal.privacy.clauses');
      if (Array.isArray(rawClauses) && rawClauses.length > 0) {
        return rawClauses;
      }
    } catch {
      // Fallback below keeps compatibility with legacy single-string content.
    }

    try {
      const content = t('legal.privacy_content');
      return String(content)
        .split(/\n\n(?=\d+\.)/)
        .map((item) => item.trim())
        .filter(Boolean);
    } catch {
      return [];
    }
  })();

  return (
    <div className="min-h-screen bg-[#020617] text-white relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] h-[32rem] w-[32rem] rounded-full bg-cyan-500/10 blur-[120px]" />
        <div className="absolute bottom-[-15%] left-[-5%] h-[28rem] w-[28rem] rounded-full bg-emerald-500/10 blur-[120px]" />
      </div>

      <main className="relative z-10 mx-auto flex min-h-screen w-full max-w-5xl flex-col px-6 py-10 md:px-8 md:py-16">
        <div>
          <Link
            href={`/${locale}`}
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-slate-950/60 px-4 py-2 text-sm font-semibold text-slate-200 transition hover:border-cyan-400/40 hover:text-cyan-300"
          >
            <span aria-hidden="true">&larr;</span>
            {t('legal.back')}
          </Link>
        </div>

        <section className="mt-8 overflow-hidden rounded-[2rem] border border-white/10 bg-slate-950/70 shadow-[0_30px_120px_rgba(2,6,23,0.55)] backdrop-blur-xl">
          <div className="border-b border-white/10 px-8 py-10 md:px-12 md:py-14">
            <p className="text-xs font-black uppercase tracking-[0.35em] text-cyan-400">biogalfhomehealth.com Legal</p>
            <h1 className="mt-4 text-4xl font-black tracking-tight text-white md:text-5xl">
              {tLanding('footer.privacy')}
            </h1>
          </div>

          <article dir={isRtl ? 'rtl' : 'ltr'} className="px-8 py-10 md:px-12 md:py-14 space-y-6">
            {clauses.map((clause, index) => (
              <section
                key={`privacy-clause-${index}`}
                className="rounded-2xl border border-white/10 bg-slate-900/50 p-6 md:p-8"
              >
                <p className="whitespace-pre-line text-base leading-relaxed text-slate-200">{normalizeBrandCopy(clause)}</p>
              </section>
            ))}
          </article>
        </section>
      </main>
    </div>
  );
}



